/** A requestAnimationFrame loop that hands the caller a clamped delta time. */
export class Loop {
	private rafId = 0;
	private last = 0;
	private running = false;

	constructor(private readonly onFrame: (dt: number) => void) {}

	start(): void {
		if (this.running) return;
		this.running = true;
		this.last = performance.now();
		this.rafId = requestAnimationFrame(this.tick);
	}

	stop(): void {
		this.running = false;
		cancelAnimationFrame(this.rafId);
	}

	private readonly tick = (now: number): void => {
		if (!this.running) return;
		let dt = (now - this.last) / 1000;
		this.last = now;
		// Clamp to avoid a huge catch-up after a background tab / breakpoint.
		if (dt > 0.1) dt = 0.1;
		this.onFrame(dt);
		this.rafId = requestAnimationFrame(this.tick);
	};
}
